import { api } from '../HttpService.js'


export const fetchSellers = async () =>  await api.integrations.get(`/omie/sellers/`)